const esCO= {
    login: {
      title: 'Iniciar sesión',
      sign_in_btn: 'Iniciar sesión'
    },
    bar: {
        logout: 'Cerrar sesión',
        languages: 'Idiomas',
        settings: 'Abrir configuración'
    },
    language: {
      name: 'Inglés (EE. UU.)',
    },
    attributePage: {
        title: 'Cambios de atributos',
        viewChanges: 'Ver cambios',
        dateTime: 'Fecha',
        notificationType: 'Tipo de notificación',
        notificationValue: 'Valor de notificación',
        oldValue: 'Valor anterior',
        newValue: 'Valor nuevo',
        accept: 'Aceptar',
        reject: 'Rechazar',
    },
    Home: 'Inicio',
    load: 'Realizando carga inicial...',
    Requested: "Solicitado",
    Viewed: "Visto",
    Executing: "Ejecutando",
    Completed: "Completado",
    Expired: "Expirado",
    Cancelled: "Cancelado",
    Error: "Error",
    Rejected: "Rechazado",
    error: 'Algo salió mal; inténtelo de nuevo más tarde.',
    displayname: 'Nombre para mostrar',
    givenname: 'Nombre',
    surname: 'Apellido',
    email: 'Correo electrónico',
    mail: 'Correo electrónico',
    name: 'Nombre',
    firstname: 'Nombre',
    lastname: 'Apellido',
    footer_copyright: 'Todos los derechos reservados.'
  };
  
  export default esCO;
  